module.exports = __webpack_public_path__ + "static/img/slide_1_en.7f53457.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_1_en.svg
// module id = QkP6
// module chunks = 0